import React, { useEffect, useState } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';
import { DropDownDirectionType } from 'react-native-dropdown-picker';
import { StyleProp, TextStyle } from 'react-native';
import { polygonService } from '../services/central-api/polygons';
import { useCurrentApp } from '../context/CurrentApp';

interface Props {
    values: number[];
    setValues: React.Dispatch<React.SetStateAction<number[]>>;
    polygonType?: string;
    dropDownDirection?: DropDownDirectionType;
    zIndex: number;
    label?: string;
    showTooltip?: boolean;
    tooltipText?: string;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    setPendingLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    companyId?: number;
    requiresCompanyId?: boolean;
    disabled?: boolean;
    required?: boolean;
}

export default function PolygonsByTypeDropdown({
    values,
    setValues,
    polygonType,
    dropDownDirection,
    zIndex,
    label,
    showTooltip,
    tooltipText,
    labelStyle,
    viewStyle,
    setPendingLoading,
    companyId,
    requiresCompanyId,
    disabled,
    required
}: Props) {
    const { isParentApp } = useCurrentApp();

    const [polygons, setPolygons] = useState<{ label: string; value: number; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    async function getPolygonsByType(polygonType: string) {
        try {
            setPendingLoading?.(true);
            setIsLoading(true);
            const resp = await polygonService.getPolygonsByType(polygonType, isParentApp && companyId && requiresCompanyId ? companyId : undefined);
            setPolygons(resp.map((polygon) => {
                return {
                    label: polygon.name,
                    value: polygon.id
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setPendingLoading?.(false);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if ((requiresCompanyId && isParentApp && !companyId) || !polygonType) {
            return;
        }
        setPolygons([]);
        getPolygonsByType(polygonType);
    }, [polygonType, isParentApp, companyId]);

    return (
        <FilterDropdown
            label={label}
            items={polygons}
            multiple={true}
            zIndex={zIndex}
            value={values}
            setValue={setValues}
            mode='BADGE'
            dropDownDirection={dropDownDirection ?? 'TOP'}
            placeholder={translate('subRegions')}
            tooltipText={tooltipText}
            showTooltip={showTooltip}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            required={required !== undefined ? required : true}
            disabled={disabled}
            loading={isLoading}
        />
    );
}
